var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.402,
    height: 104.547,
    viewBox: "0 0 188.402 104.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_mass",
    transform: "translate(-6.75 -978.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4097",
    d: "M12.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4097",
    transform: "translate(0 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4098",
    d: "M12.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4098",
    transform: "translate(0 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4099",
    d: "M12.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4099",
    transform: "translate(0 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4100",
    d: "M12.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4100",
    transform: "translate(0 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    d: "M12.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4101",
    transform: "translate(0 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4102",
    d: "M12.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4102",
    transform: "translate(0 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4103",
    d: "M12.2 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4103",
    transform: "translate(0 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4104",
    d: "M15.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4104",
    transform: "translate(4.123 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4105",
    d: "M15.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4105",
    transform: "translate(4.123 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4106",
    d: "M15.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4106",
    transform: "translate(4.123 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4107",
    d: "M15.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4107",
    transform: "translate(4.123 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4108",
    d: "M15.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4108",
    transform: "translate(4.123 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    d: "M15.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4109",
    transform: "translate(4.123 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    d: "M15.7 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4110",
    transform: "translate(4.123 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    d: "M19.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4111",
    transform: "translate(8.246 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    d: "M19.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4112",
    transform: "translate(8.246 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    d: "M19.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4113",
    transform: "translate(8.246 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    d: "M19.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4114",
    transform: "translate(8.246 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    d: "M19.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4115",
    transform: "translate(8.246 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    d: "M19.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4116",
    transform: "translate(8.246 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    d: "M19.2 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4117",
    transform: "translate(8.246 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    d: "M22.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4118",
    transform: "translate(12.37 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    d: "M22.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4119",
    transform: "translate(12.37 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    d: "M22.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4120",
    transform: "translate(12.37 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4121",
    d: "M22.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4121",
    transform: "translate(12.37 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    d: "M22.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4122",
    transform: "translate(12.37 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4123",
    d: "M22.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4123",
    transform: "translate(12.37 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4124",
    d: "M26.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4124",
    transform: "translate(16.493 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    d: "M26.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4125",
    transform: "translate(16.493 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4126",
    d: "M26.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4126",
    transform: "translate(16.493 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    d: "M26.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4127",
    transform: "translate(16.493 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    d: "M26.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4128",
    transform: "translate(16.493 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    d: "M26.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4129",
    transform: "translate(16.493 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    d: "M29.7 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4130",
    transform: "translate(20.616 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    d: "M29.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4131",
    transform: "translate(20.616 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    d: "M29.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4132",
    transform: "translate(20.616 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    d: "M29.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4133",
    transform: "translate(20.616 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    d: "M29.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4134",
    transform: "translate(20.616 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4135",
    d: "M29.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4135",
    transform: "translate(20.616 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    d: "M29.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4136",
    transform: "translate(20.616 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    d: "M33.2 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4137",
    transform: "translate(24.739 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    d: "M33.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4138",
    transform: "translate(24.739 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4139",
    d: "M33.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4139",
    transform: "translate(24.739 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    d: "M33.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4140",
    transform: "translate(24.739 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    d: "M33.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4141",
    transform: "translate(24.739 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    d: "M33.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4142",
    transform: "translate(24.739 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    d: "M33.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4143",
    transform: "translate(24.739 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4144",
    d: "M36.7 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4144",
    transform: "translate(28.862 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4145",
    d: "M36.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4145",
    transform: "translate(28.862 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    d: "M36.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4146",
    transform: "translate(28.862 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    d: "M36.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4147",
    transform: "translate(28.862 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    d: "M36.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4148",
    transform: "translate(28.862 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    d: "M36.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4149",
    transform: "translate(28.862 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    d: "M40.2 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4150",
    transform: "translate(32.986 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    d: "M40.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4151",
    transform: "translate(32.986 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    d: "M40.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4152",
    transform: "translate(32.986 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    d: "M40.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4153",
    transform: "translate(32.986 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    d: "M40.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4154",
    transform: "translate(32.986 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    d: "M40.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4155",
    transform: "translate(32.986 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    d: "M43.7 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4156",
    transform: "translate(37.109 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    d: "M43.7 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4157",
    transform: "translate(37.109 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    d: "M43.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4158",
    transform: "translate(37.109 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    d: "M43.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4159",
    transform: "translate(37.109 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    d: "M43.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4160",
    transform: "translate(37.109 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    d: "M43.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4161",
    transform: "translate(37.109 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    d: "M43.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4162",
    transform: "translate(37.109 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    d: "M47.2 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4163",
    transform: "translate(41.232 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    d: "M47.2 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4164",
    transform: "translate(41.232 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    d: "M47.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4165",
    transform: "translate(41.232 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    d: "M47.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4166",
    transform: "translate(41.232 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    d: "M47.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4167",
    transform: "translate(41.232 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    d: "M47.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4168",
    transform: "translate(41.232 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    d: "M47.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4169",
    transform: "translate(41.232 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    d: "M50.7 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4170",
    transform: "translate(45.355 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    d: "M50.7 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4171",
    transform: "translate(45.355 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    d: "M50.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4172",
    transform: "translate(45.355 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    d: "M50.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4173",
    transform: "translate(45.355 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    d: "M50.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4174",
    transform: "translate(45.355 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    d: "M50.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4175",
    transform: "translate(45.355 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    d: "M50.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4176",
    transform: "translate(45.355 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    d: "M54.2 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4177",
    transform: "translate(49.479 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    d: "M54.2 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4178",
    transform: "translate(49.479 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    d: "M54.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4179",
    transform: "translate(49.479 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    d: "M54.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4180",
    transform: "translate(49.479 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    d: "M54.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4181",
    transform: "translate(49.479 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    d: "M54.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4182",
    transform: "translate(49.479 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    d: "M57.7 988.085a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4183",
    transform: "translate(53.602 8.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    d: "M57.7 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4184",
    transform: "translate(53.602 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    d: "M57.7 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4185",
    transform: "translate(53.602 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    d: "M57.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4186",
    transform: "translate(53.602 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    d: "M57.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4187",
    transform: "translate(53.602 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    d: "M57.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4188",
    transform: "translate(53.602 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    d: "M57.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4189",
    transform: "translate(53.602 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    d: "M61.2 984.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4190",
    transform: "translate(57.725 4.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    d: "M61.2 988.085a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4191",
    transform: "translate(57.725 8.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    d: "M61.2 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4192",
    transform: "translate(57.725 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    d: "M61.2 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4193",
    transform: "translate(57.725 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    d: "M61.2 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4194",
    transform: "translate(57.725 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    d: "M61.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4195",
    transform: "translate(57.725 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    d: "M61.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4196",
    transform: "translate(57.725 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    d: "M61.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4197",
    transform: "translate(57.725 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    d: "M61.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4198",
    transform: "translate(57.725 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    d: "M64.7 981.085a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4199",
    transform: "translate(61.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    d: "M64.7 984.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4200",
    transform: "translate(61.848 4.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4201",
    d: "M64.7 988.085a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4201",
    transform: "translate(61.848 8.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    d: "M64.7 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4202",
    transform: "translate(61.848 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    d: "M64.7 995.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4203",
    transform: "translate(61.848 16.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    d: "M64.7 998.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4204",
    transform: "translate(61.848 20.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    d: "M64.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4205",
    transform: "translate(61.848 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    d: "M64.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4206",
    transform: "translate(61.848 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    d: "M64.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4207",
    transform: "translate(61.848 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    d: "M64.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4208",
    transform: "translate(61.848 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    d: "M64.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4209",
    transform: "translate(61.848 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    d: "M68.2 984.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4210",
    transform: "translate(65.971 4.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4211",
    d: "M68.2 988.085a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4211",
    transform: "translate(65.971 8.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    d: "M68.2 991.585a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4212",
    transform: "translate(65.971 12.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    d: "M68.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4213",
    transform: "translate(65.971 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    d: "M68.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4214",
    transform: "translate(65.971 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    d: "M68.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4215",
    transform: "translate(65.971 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4216",
    d: "M68.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4216",
    transform: "translate(65.971 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    d: "M68.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4217",
    transform: "translate(65.971 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    d: "M68.2 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4218",
    transform: "translate(65.971 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    d: "M68.2 1023.085a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4219",
    transform: "translate(65.971 49.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    d: "M71.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4220",
    transform: "translate(70.095 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    d: "M71.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4221",
    transform: "translate(70.095 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    d: "M71.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4222",
    transform: "translate(70.095 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    d: "M71.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4223",
    transform: "translate(70.095 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    d: "M71.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4224",
    transform: "translate(70.095 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    d: "M71.7 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4225",
    transform: "translate(70.095 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4226",
    d: "M71.7 1023.085a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4226",
    transform: "translate(70.095 49.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    d: "M75.2 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4227",
    transform: "translate(74.218 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    d: "M75.2 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4228",
    transform: "translate(74.218 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4229",
    d: "M75.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4229",
    transform: "translate(74.218 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4230",
    d: "M75.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4230",
    transform: "translate(74.218 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4231",
    d: "M75.2 1026.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4231",
    transform: "translate(74.218 53.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    d: "M78.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4232",
    transform: "translate(78.341 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    d: "M78.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4233",
    transform: "translate(78.341 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    d: "M78.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4234",
    transform: "translate(78.341 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4235",
    d: "M78.7 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4235",
    transform: "translate(78.341 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4236",
    d: "M78.7 1023.085a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4236",
    transform: "translate(78.341 49.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4237",
    d: "M82.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4237",
    transform: "translate(82.464 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4238",
    d: "M82.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4238",
    transform: "translate(82.464 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4239",
    d: "M82.2 1019.585a2.723 2.723 0 1 1-2.723-2.723 2.722 2.722 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4239",
    transform: "translate(82.464 45.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4240",
    d: "M82.2 1026.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4240",
    transform: "translate(82.464 53.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    d: "M85.7 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4241",
    transform: "translate(86.587 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4242",
    d: "M85.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4242",
    transform: "translate(86.587 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    d: "M85.7 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4243",
    transform: "translate(86.587 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    d: "M85.7 1026.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4244",
    transform: "translate(86.587 53.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    d: "M89.2 1002.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4245",
    transform: "translate(90.711 24.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    d: "M89.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4246",
    transform: "translate(90.711 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    d: "M89.2 1016.085a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4247",
    transform: "translate(90.711 41.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    d: "M92.7 1005.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4248",
    transform: "translate(94.834 28.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    d: "M92.7 1009.085a2.723 2.723 0 1 1-2.722-2.722 2.722 2.722 0 0 1 2.722 2.722z",
    className: "cls-1",
    "data-name": "Path 4249",
    transform: "translate(94.834 32.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    d: "M92.7 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4250",
    transform: "translate(94.834 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    d: "M92.7 1026.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4251",
    transform: "translate(94.834 53.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    d: "M96.2 1012.585a2.723 2.723 0 1 1-2.722-2.723 2.723 2.723 0 0 1 2.722 2.723z",
    className: "cls-1",
    "data-name": "Path 4252",
    transform: "translate(98.957 37.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    d: "M96.2 1023.085a2.723 2.723 0 1 1-2.723-2.722 2.723 2.723 0 0 1 2.723 2.722z",
    className: "cls-1",
    "data-name": "Path 4253",
    transform: "translate(98.957 49.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    d: "M96.2 1026.585a2.723 2.723 0 1 1-2.723-2.723 2.723 2.723 0 0 1 2.723 2.723z",
    className: "cls-1",
    "data-name": "Path 4254",
    transform: "translate(98.957 53.602)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMass);
export default __webpack_public_path__ + "static/media/icon-mass.10c4bb9650621ff52370ded11a9bf3ab.svg";
export { ForwardRef as ReactComponent };